<div class="international-fields-container">
    <!-- City -->
    <mm-text-input-control class="medium-bottom-spacer" id="checkTransactionDetails_internationalCity"
        [parentForm]="parentForm" [inputControlModel]="cityModel" [errorMessage]="cityError">
    </mm-text-input-control>

    <!-- State/Province/Region -->
    <mm-text-input-control class="medium-bottom-spacer" id="checkTransactionDetails_stateProvince"
        [parentForm]="parentForm" [inputControlModel]="stateProvinceModel">
    </mm-text-input-control>

    <!-- ZIP/Postal code -->
    <mm-text-input-control class="medium-bottom-spacer" id="checkTransactionDetails_postalCode" [parentForm]="parentForm"
        [inputControlModel]="postalCodeModel" [errorMessage]="zipCodeError">
    </mm-text-input-control>

    <!-- Country -->
    <mm-select-dropdown-control id="checkTransactionDetails_countryListDropdown" [parentForm]="parentForm"
        [selectModel]="countryListDropdown" [showSelectOne]="true" [showBlankOption]="true">
    </mm-select-dropdown-control>
</div>
